// Libraries
import React from 'react'
import PropTypes from 'prop-types'
import { Field } from 'formik'
import { Tooltip } from 'antd'
// Styles
import { Title, Input } from '../../../EditProfile/Inputs/styles.js'
import { ErrorMessage } from '../styles'

const TextInput = ({ name, title, style, label, tooltip, ...props }) => {
  const onChangeUpdated = (form) =>
    props.onChange ? props.onChange : (event) => form.setFieldValue(name, event?.target?.value)
  const renderTitle = () => {
    if (tooltip) {
      return (
        <Tooltip {...tooltip}>
          <Title>{title}:</Title>
        </Tooltip>
      )
    } else {
      return <Title>{title}:</Title>
    }
  }
  return (
    <div style={style}>
      {title && renderTitle()}
      {label && <label htmlFor={name}>{label}</label>}
      <Field id={name} name={name} {...props}>
        {({ field, form }) => (
          <div>
            <Input
              {...props}
              value={field.value}
              onChange={onChangeUpdated(form)}
              onBlur={() => form.setFieldTouched(name, true)}
            />
            <ErrorMessage name={name} component='div' className='error' />
          </div>
        )}
      </Field>
    </div>
  )
}

TextInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  title: PropTypes.string,
  onChange: PropTypes.func,
  style: PropTypes.object,
  tooltip: PropTypes.object
}

export default TextInput
